import "../pages.scss"
import { OfertasCabState } from '../../context/ofertascab/OfertasCabState';
import Datatable from "./ofertasCabTable/Datatable"

const OfertasCabPage = () => {
  return (
    <>
      <OfertasCabState>
        <Datatable />
      </OfertasCabState>

    </>
  )
}

export default OfertasCabPage